
// src/components/Loader/FullScreenLoader.tsx

import sagilityLogo from '../../assets/Logo/sagility-logo-icon.png';

const FullScreenLoader = () => {
  return (
    <div
      className="
        fixed
        inset-0
        z-[9999]
        flex
        min-h-[100dvh]
        w-full
        items-center
        justify-center
        overflow-hidden
        bg-white/95
        backdrop-blur-sm
      "
    >
      <div
        className="
          flex
          w-auto
          max-w-[90vw]
          flex-col
          items-center
          justify-center
        "
      >

        {/* =====================================================
            LOGO LOADER
        ====================================================== */}

        <div
          className="
            relative
            flex
            h-[88px]
            w-[88px]
            items-center
            justify-center

            sm:h-[92px]
            sm:w-[92px]
          "
        >

          {/* =====================================================
              OUTER BORDER
          ====================================================== */}

          <div
            className="
              absolute
              inset-0
              rounded-full
              border-[3px]
              border-[#E5EEFF]
            "
          />

          {/* =====================================================
              ANIMATED BORDER
          ====================================================== */}

          <div
            className="
              absolute
              inset-0
              animate-spin
              rounded-full
              border-[3px]
              border-transparent
              border-t-[#2563EB]
              border-r-[#06B6D4]
            "
          />

          {/* =====================================================
              LOGO CONTAINER
          ====================================================== */}

          <div
            className="
              flex
              h-[64px]
              w-[64px]
              items-center
              justify-center
              rounded-full
              bg-white
              shadow-[0_6px_20px_rgba(37,99,235,0.12)]

              sm:h-[68px]
              sm:w-[68px]
            "
          >
            <img
              src={sagilityLogo}
              alt="Sagility"
              className="
                h-[34px]
                w-auto
                animate-pulse
                object-contain

                sm:h-[36px]
              "
            />
          </div>
        </div>


        {/* =====================================================
            LOADING TEXT
        ====================================================== */}

        <div
          className="
            mt-[18px]
            flex
            items-center
            justify-center
            whitespace-nowrap
          "
        >
          <span
            className="
              text-[17px]
              font-semibold
              tracking-[-0.15px]
              text-[#101828]

              sm:text-[18px]
            "
          >
            Loading
          </span>

          <span className="loading-dot">
            .
          </span>

          <span className="loading-dot loading-dot-1">
            .
          </span>

          <span className="loading-dot loading-dot-2">
            .
          </span>
        </div>


        {/* =====================================================
            DESCRIPTION
        ====================================================== */}

        <p
          className="
            mt-[5px]
            px-2
            text-center
            text-[11px]
            font-normal
            text-[#667085]

            sm:text-[12px]
          "
        >
          Preparing your WorkVista dashboard
        </p>


        {/* =====================================================
            SIMPLE PROGRESS INDICATOR
        ====================================================== */}

        <div
          className="
            mt-[14px]
            h-[3px]
            w-[120px]
            overflow-hidden
            rounded-full
            bg-[#E5E7EB]

            sm:w-[130px]
          "
        >
          <div
            className="
              loader-progress
              h-full
              w-[55%]
              rounded-full
            "
          />
        </div>

      </div>


      {/* =======================================================
          ANIMATION
      ======================================================== */}

      <style>
        {`
          .loading-dot {
            display: inline-block;
            margin-left: 2px;
            font-size: 17px;
            font-weight: 600;
            line-height: 1;
            color: #475467;
            animation: loadingDot 1.2s ease-in-out infinite;
          }

          .loading-dot-1 {
            animation-delay: 0.2s;
          }

          .loading-dot-2 {
            animation-delay: 0.4s;
          }

          @keyframes loadingDot {
            0%,
            20% {
              opacity: 0.25;
              transform: translateY(0);
            }

            50% {
              opacity: 1;
              transform: translateY(-3px);
            }

            80%,
            100% {
              opacity: 0.25;
              transform: translateY(0);
            }
          }

          .loader-progress {
            background: linear-gradient(
              90deg,
              #2563EB,
              #06B6D4,
              #2563EB
            );

            background-size: 200% 100%;

            animation:
              loaderProgress 1.5s ease-in-out infinite;
          }

          @keyframes loaderProgress {
            0% {
              transform: translateX(-100%);
              background-position: 0% 50%;
            }

            50% {
              transform: translateX(80%);
              background-position: 100% 50%;
            }

            100% {
              transform: translateX(220%);
              background-position: 0% 50%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default FullScreenLoader;
